<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <h3 class="mx-3">Grid</h3>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Grid",

  data: () => ({})
};
</script>
